const {foo} = require("bar");
const {hello} = require("world");

foo.x(...foo.y(hello.z));
